export const plans = [
	{
		value: "Basic",
		label: "Basic",
		description: ""
	},
	{
		value: "Trial",
		label: "Trial",
		description: ""
	},
	{
		value: "Active non-subscriber",
		label: "Active non-subscriber",
		description: ""
	},
	{
		value: "Subscription level 1",
		label: "Subscription level 1",
		description: ""
	},
	{
		value: "Subscription level 2",
		label: "Subscription level 2",
		description: ""
	},
	{
		value: "Subscription level 3",
		label: "Subscription level 3",
		description: ""
	}
];

export const status = [
	{
		value: "active",
		label: "Listed"
	},
	{
		value: "non-active",
		label: "Unlisted"
	}
];

export default { plans, status };
